import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  providerKeySection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  buttonContainer: {
    display: 'flex',
    gap: '16px',
  },
});